/**
 * SearchItemNoResults
 */
import React from 'react';
/** Main description for this component. */
var SearchItemNoResults = function (_a) {
    var heading = _a.heading, text = _a.text, className = _a.className, children = _a.children;
    return (React.createElement("div", { className: "pb-6 mb-3 border-b-2 lg:mb-6 border-greyLight" },
        React.createElement("h1", { className: "text-h2 leading-10" }, heading),
        text && React.createElement("p", { className: "text-p" }, text),
        children && React.createElement("div", { className: "mt-4 text-p" }, children)));
};
export default SearchItemNoResults;
